import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "motion/react";
import { transitionSoft, viewportOnce } from "../animations";

function Footer() {
  const { t } = useTranslation();

  return (
    <motion.section
      id="footer"
      className="relative mt-[84px] w-full overflow-hidden bg-gradient-to-b from-[#1a1a1a] via-[#171717] to-[#0f0f0f]"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={viewportOnce}
      transition={{ ...transitionSoft, duration: 0.6 }}
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#da0011]/70 to-transparent" />
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        style={{
          background:
            "radial-gradient(900px 420px at 18% 30%, rgba(218,0,17,0.10) 0%, rgba(218,0,17,0) 60%), radial-gradient(700px 360px at 88% 35%, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0) 55%)",
        }}
        aria-hidden
      />
      <div className="m-auto flex flex-col justify-between px-4 py-[40px] md:flex-row md:pb-[70px] md:pt-[42px] lg:max-w-[1024px] lg:pb-[90px] lg:pt-[52px] xl:max-w-[1280px] xl:pb-[110px] xl:pt-[62px]">
        <motion.div
          className="relative md:w-[560px] lg:w-[700px] xl:w-[700px]"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ ...transitionSoft, delay: 0.05 }}
        >
          <a href="#">
            <img src="./img/logoIcbWhite.png" className="" alt="ICB" />
          </a>
          <p className="mb-[20px] mt-[24px] text-[14px] font-medium text-white/90 md:mb-[44px]">
            {t("footer.about")}
          </p>
          <div className="flex justify-between">
            <div className="flex flex-col">
              <a
                href="tel:0909"
                className="text-[10px] font-medium text-[#da0011] transition-colors hover:text-[#ff2a3a] md:text-[18px] lg:text-[20px] xl:text-[24px]"
              >
                0909
              </a>
              <span className="whitespace-pre-line text-[12px] font-medium text-white">
                {t("footer.phoneInNetwork")}
              </span>
            </div>
            <div className="flex flex-col border-x-2 border-[#6b6b6b] px-[10px] md:px-[28px]">
              <a
                href="tel:+992 771 11 01 11 "
                className="text-[10px] font-medium text-[#da0011] transition-colors hover:text-[#ff2a3a] md:text-[18px] lg:text-[20px] xl:text-[24px]"
              >
                +992 771 11 01 11{" "}
              </a>
              <span className="whitespace-pre-line text-[12px] font-medium text-white">
                {t("footer.phoneOutNetwork")}
              </span>
            </div>
            <div className="ml-[4px] flex flex-col md:ml-[0]">
              <a
                href="tel:+992 44 600 1520"
                className="text-[10px] font-medium text-[#da0011] transition-colors hover:text-[#ff2a3a] md:text-[18px] lg:text-[20px] xl:text-[24px]"
              >
                +992 44 600 1520
              </a>
              <span className="whitespace-pre-line text-[12px] font-medium text-white">
                {t("footer.trustLine")}
              </span>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="relative flex justify-between md:flex-col"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ ...transitionSoft, delay: 0.12 }}
        >
          <div>
            <p className="mb-[22px] mt-[24px] text-[14px] font-medium text-white/90">
              {t("footer.socialTitle")}
            </p>
            <ul className="flex space-x-[33px]">
              <li>
                <motion.a
                  href="https://www.facebook.com/TheFirstMicroFinanceBankTajikistan"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.08, y: -2 }}
                  whileTap={{ scale: 0.96 }}
                  className="opacity-85 transition-opacity hover:opacity-100"
                >
                  <img src="./img/facebook.svg" alt="" />
                </motion.a>
              </li>
              <li>
                <motion.a
                  href="https://www.instagram.com/icb.tajikistan/"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.08, y: -2 }}
                  whileTap={{ scale: 0.96 }}
                  className="opacity-85 transition-opacity hover:opacity-100"
                >
                  <img src="./img/instagram.svg" alt="" />
                </motion.a>
              </li>
              <li>
                <motion.a
                  href="https://t.me/icb_new_bot"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.08, y: -2 }}
                  whileTap={{ scale: 0.96 }}
                  className="opacity-85 transition-opacity hover:opacity-100"
                >
                  <img src="./img/telegram.svg" alt="" />
                </motion.a>
              </li>
              <li>
                <motion.a
                  href="https://www.linkedin.com/company/the-first-microfinance-bank-tajikistan/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.08, y: -2 }}
                  whileTap={{ scale: 0.96 }}
                  className="opacity-85 transition-opacity hover:opacity-100"
                >
                  <img src="./img/lining.svg" alt="" />
                </motion.a>
              </li>
            </ul>
            {/* <ul className="mt-[26px] flex space-x-[33px]">
              <li>
                <motion.a
                  href="#"
                  whileHover={{ scale: 1.08, y: -2 }}
                  whileTap={{ scale: 0.96 }}
                >
                  <img src="./img/tviter.svg" alt="" />
                </motion.a>
              </li>

              <li>
                <motion.a
                  href="#"
                  whileHover={{ scale: 1.08, y: -2 }}
                  whileTap={{ scale: 0.96 }}
                >
                  <img src="./img/youTube.svg" alt="" />
                </motion.a>
              </li>
            </ul> */}
          </div>
          <div>
            <p className="mb-[17px] mt-[24px] text-[14px] font-medium text-white/90 md:mt-[39px]">
              {t("footer.appTitle")}
            </p>
            <ul className="flex space-x-[3px]">
              <li>
                <motion.a
                  href="https://play.google.com/store/apps/details?id=tj.fmfb.mobile&hl=ru&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.97 }}
                  className="opacity-90 transition-opacity hover:opacity-100"
                >
                  <img src="./img/googlePlayGray2.svg" alt="" />
                </motion.a>
              </li>
              <li>
                <motion.a
                  href="https://itunes.apple.com/app/id1641458468"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.97 }}
                  className="opacity-90 transition-opacity hover:opacity-100"
                >
                  <img src="./img/appStoreGray.svg" alt="" />
                </motion.a>
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
}

export default Footer;
